<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-7.15,799.77l-0.26-0.27l-2.09-2.08v-9.85l2.35-2.35h15.3l2.35,2.35v9.85l-2.35,2.35H-7.15z M-4.04,796.62l10-4.12
	l-10-4.12l1.82,4.12L-4.04,796.62z"/>
</svg>

</template>